import { auth } from "../firebase.web";

/**
 * True while the browser is still signed in as `uid`. Firebase auth is shared across tabs, so an
 * async write started by one account must re-check this right before it writes: after an account
 * switch the request would carry the other account's token with this account's `uid` in the payload.
 */
export const signedInAs = (uid) => !!uid && auth.currentUser?.uid === uid;
